import { CategoryPageTemplate } from './CategoryPageTemplate'

export function BreastSurgeryPage() {
  return <CategoryPageTemplate categoryKey="breastSurgery" namespace="breastSurgery" />
}
